<div id="divSessionLive" (mousemove)="SessionLive()">
    <app-splash-screen></app-splash-screen>
    <router-outlet></router-outlet>
</div>
